import CollectionsHome from "../../../jsx/components/Dashboard/CollectionsHome";

const HomeWrapper = () => {
  return <CollectionsHome />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.collections];
export default constore(HomeWrapper);
